import { render, staticRenderFns } from "./DesmatamentoVega2025ComSoja2425VegaParaguai.vue?vue&type=template&id=0acdb8c6&scoped=true&lang=pug"
import script from "./DesmatamentoVega2025ComSoja2425VegaParaguai.vue?vue&type=script&lang=js"
export * from "./DesmatamentoVega2025ComSoja2425VegaParaguai.vue?vue&type=script&lang=js"
import style0 from "./DesmatamentoVega2025ComSoja2425VegaParaguai.vue?vue&type=style&index=0&id=0acdb8c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0acdb8c6",
  null
  
)

export default component.exports